export default {
  name: 'gmk-nautilus',
  override: {
    KC_ENT: 'accent',
    KC_ESC: 'accent'
  }
};
